import { UserRole } from '../features/user/domain';

export const redirectHelper = {
  getAfterLogInRedirectUrl(userRole: string): string {
    return userRole === UserRole.Player ? '/Account/Contact' : '/';
  },
};
